export default __webpack_public_path__ + "static/media/redtiger.2aabafe3.svg";